export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M8 21.5h8c1.1 0 2-.9 2-2v-11H6v11c0 1.1.9 2 2 2m8-17-1.5-2h-5L8 4.5H5v2h14v-2z\"/>"
};